<template>
    <div class="position-fixed bottom-4 end-4" style="z-index: 999;">
        <CardComponent :p="0" :withmin="false">
            <p
                class="cursor-pointer text-end mb-0"
                style="color: #0385f3"
                data-bs-target="#modalProcessSync"
                data-bs-toggle="modal"
                @click="$emit('open-modal-sync')"
            >
                Lihat Detail
            </p>
            <div class="d-flex flex-row flex-grow-1 align-items-center gap-4 position-relative">
                <div class="spinner-border" style="width: 3rem; height: 3rem;" aria-hidden="true"></div>
                <div class="d-flex flex-column flex-wrap gap-2">
                    <h6 class="m-0">Proses Sinkronisasi sedang diproses</h6>
                    <p class="m-0">{{ current }} dari {{ total }} data pegawai sedang dalam proses sinkronisasi</p>
                </div>
            </div>
        </CardComponent>
    </div>
</template>

<script>
import EmployeesApi from '../repository/api/EmployeesApi';
import CardComponent from './CardComponent.vue';

export default {
    name: "ProgressSync",
    props: ['current', 'total'],
    components: {
        CardComponent,
    },
    data() {
        return {
            checkInterval: 3000
        }
    },

    methods: {
        async checkSync() {
            await EmployeesApi.getsynchronize({ 'status': 'running' }).then(() => {
                this.$store.state.syncing = true
            }).catch(() => {
                this.$store.state.syncing = false;
            })
        }
    },
}
</script>